import { render } from "./App.vue?vue&type=template&id=3987eeca"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=3987eeca&lang=css"

import exportComponent from "/www/wwwroot/v.vutet.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__